<app-change-password-dialog key="changePassword"></app-change-password-dialog>

<kpd-side-panel [facade]="userFacade" [entityName]="'User' | translate" (itemChanged)="onItemChange($event)">
  <ng-template kpdTemplate="actionbar" let-selection let-loading="loading" let-deleted="deleted">
    <kpd-action-create
      (action)="onAdd()"
      [title]="'Add user' | translate"
      *kpdPermission="Permissions.UserCreate"
    ></kpd-action-create>
    <download-import-template *kpdPermission="Permissions.UserImport"></download-import-template>
    <app-import *kpdPermission="Permissions.UserImport" (importDone)="reloadData()"> </app-import>
    <ng-container *ngIf="selection.length !== 0 && !deleted">
      <kpd-action-consult-overview (action)="onView(selection[0])" [disable]="loading"></kpd-action-consult-overview>
      <kpd-action-edit-toggle
        (action)="onEdit(selection[0])"
        *kpdPermission="Permissions.UserUpdate"
        [disable]="loading"
        [readMode]="false"
      ></kpd-action-edit-toggle>
      <kpd-action-delete
        (action)="onDelete(selection)"
        *kpdPermission="Permissions.UserDelete"
        [disable]="loading || (isSystemUserSelected | async)"
      ></kpd-action-delete>
    </ng-container>
  </ng-template>

  <ng-template kpdTemplate="singleItem" let-item>
    <h3 translate>General</h3>
    <div class="flex-row flex-wrap">
      <div class="flex-column">
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>UPN</label>
          <label class="value">{{ item.upn | kpdDefault }}</label>
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>First name</label>
          <label class="value">{{ item.firstName | kpdDefault }}</label>
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Last name</label>
          <label class="value">{{ item.lastName | kpdDefault }}</label>
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Name</label>
          <label class="value">{{ item.displayName | kpdDefault }}</label>
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Email</label>
          <label class="value">{{ item.email | kpdDefault }}</label>
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Language</label>
          <label class="value">{{ getCultureByCultureString(item.culture) | kpdDefault }}</label>
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Type</label>
          <label class="value">
            <span *ngFor="let provider of getAuthProviders(item)">
              {{ provider }}
              <br />
            </span>
          </label>
        </div>
        <div class="read-group flex-row read-sidepannel" *ngIf="item.isSystemUser">
          <label class="title" translate>System User</label>
          <clr-icon shape="check"></clr-icon>
        </div>
      </div>
    </div>
    <a (click)="changePassword()" *ngIf="canChangePassword(item)" translate>Change password</a>
  </ng-template>

  <ng-template kpdTemplate="multiItem" let-item>
    <div class="card-small">
      <label class="card__header">
        <span class="card__multival flex-row">
          <div class="code">{{ item.displayName }}</div>
          <div class="name">{{ item.upn }}</div>
        </span>
      </label>
    </div>
  </ng-template>

  <ng-template kpdTemplate="tiles" let-item>
    <kpd-tile
      icon="file-group"
      [title]="'Licenses' | translate"
      [value]="userLicensesCount"
      (click)="navigateToLicenses(item.upn)"
    ></kpd-tile>
    <kpd-tile
      icon="users"
      [title]="'Roles' | translate"
      [value]="userRoleCount"
      (click)="navigateToRoles(item.upn)"
    ></kpd-tile>
  </ng-template>
  <kpd-side-panel> </kpd-side-panel
></kpd-side-panel>
